<form class="dropzone" #dropzone>
  <div class="dz-message">
    Drop files here or click to upload.
    <br>
    <span class="note">
      (Selected files are uploaded and processed)
      </span>
  </div>
</form>
